import { Badge, Text, makeStyles, tokens } from '@fluentui/react-components'
import { NavLink } from 'react-router-dom'
import { NAV_SECTIONS } from './nav'
import { useAuthStore } from '@/stores/auth'
import { useUiStore } from '@/stores/ui'
import { isAdmin } from '@/utils/auth'

const useStyles = makeStyles({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    overflowY: 'auto',
    padding: '8px 10px 24px',
  },
  brand: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    padding: '10px 10px 14px',
    textDecoration: 'none',
    color: 'inherit',
  },
  brandImg: { width: '34px', height: '34px', borderRadius: '8px' },
  sectionTitle: {
    margin: '14px 12px 4px',
    fontSize: '11px',
    fontWeight: 600,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: tokens.colorNeutralForeground4,
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '9px 12px',
    borderRadius: '8px',
    color: tokens.colorNeutralForeground2,
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    position: 'relative',
    transition: 'background-color 0.15s ease, color 0.15s ease',
    '&:hover': {
      backgroundColor: tokens.colorNeutralBackground1Hover,
      color: tokens.colorNeutralForeground1,
      textDecoration: 'none',
    },
  },
  itemActive: {
    backgroundColor: tokens.colorBrandBackground2,
    color: tokens.colorBrandForeground1,
    fontWeight: 600,
    '&:hover': {
      backgroundColor: tokens.colorBrandBackground2Hover,
      color: tokens.colorBrandForeground1,
    },
  },
  indicator: {
    position: 'absolute',
    left: '0px',
    top: '18%',
    bottom: '18%',
    width: '3px',
    borderRadius: '2px',
    backgroundColor: tokens.colorBrandForeground1,
  },
  icon: {
    display: 'inline-flex',
    fontSize: '18px',
    flexShrink: 0,
  },
})

export function SidebarNav() {
  const s = useStyles()
  const user = useAuthStore((st) => st.user)
  const unread = useUiStore((st) => st.unreadMessages)
  const admin = user ? isAdmin(user) : false

  return (
    <div className={s.root}>
      <NavLink to="/" className={s.brand}>
        <img src="/idvevent-logo.png" alt="Idvevent" className={s.brandImg} />
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.2 }}>
          <Text weight="semibold" size={400}>
            Idvevent 赛事平台
          </Text>
          <Text size={100} style={{ color: tokens.colorNeutralForeground3 }}>
            第五人格统一赛事管理
          </Text>
        </div>
      </NavLink>

      {NAV_SECTIONS.filter((sec) => !sec.adminOnly || admin).map((sec, i) => (
        <div key={i}>
          {sec.title && <div className={s.sectionTitle}>{sec.title}</div>}
          {sec.items
            .filter((it) => !it.adminOnly || admin)
            .map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                className={({ isActive }) => `${s.item}${isActive ? ` ${s.itemActive}` : ''}`}
              >
                {({ isActive }) => (
                  <>
                    {isActive && <span className={s.indicator} />}
                    <span className={s.icon}>{it.icon}</span>
                    <span style={{ flex: 1 }}>{it.label}</span>
                    {it.to === '/messages' && unread > 0 && (
                      <Badge appearance="filled" color="danger" size="small">
                        {unread > 99 ? '99+' : unread}
                      </Badge>
                    )}
                  </>
                )}
              </NavLink>
            ))}
        </div>
      ))}
    </div>
  )
}
